import MuiButton from './MuiButton';
import MuiChip from './MuiChip';
import MuiFab from './MuiFab';
import MuiFilledInput from './MuiFilledInput';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiLinearProgress from './MuiLinearProgress';
import MuiListItemIcon from './MuiListItemIcon';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiSvgIcon from './MuiSvgIcon';
import MuiTab from './MuiTab';
import MuiTableCell from './MuiTableCell';
import MuiTableRow from './MuiTableRow';
import MuiTabs from './MuiTabs';

export default {
    MuiButton,
    MuiChip,
    MuiFab,
    MuiFilledInput,
    MuiIconButton,
    MuiInputBase,
    MuiLinearProgress,
    MuiListItemIcon,
    MuiOutlinedInput,
    MuiSvgIcon,
    MuiTab,
    MuiTableCell,
    MuiTableRow,
    MuiTabs,
    MuiPaper: {
        styleOverrides: {
            rounded: {
                borderRadius: 12,
            },
        },
    },
    MuiCard: {
        styleOverrides: {
            root: {
                borderRadius: 12,
                boxShadow: '0px 4px 6px rgba(17, 24, 39, 0.06), 0px 10px 15px rgba(17, 24, 39, 0.1)',
            },
        },
    },
};
